import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable class-methods-use-this */
import React from 'react';
import { Button, Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import InternalLink from '../../atoms/InternalLink';
import Map from '../../atoms/Map';
import OutboundLink from '../../atoms/OutboundLink';
import Event from '../../modules/analytics/components/Event';
import ImageBanner from '../../molecules/ImageBanner';
import { GatsbyImagePropType } from '../../services/proptypes';
import './HeroElement.css';
var HeroElement = /*#__PURE__*/function (_React$Component) {
  _inherits(HeroElement, _React$Component);
  var _super = _createSuper(HeroElement);
  function HeroElement() {
    _classCallCheck(this, HeroElement);
    return _super.apply(this, arguments);
  }
  _createClass(HeroElement, [{
    key: "getCTAProps",
    value: function getCTAProps(cta, index) {
      var color = cta.color,
        inverted = cta.inverted;
      var _this$props = this.props,
        ctaColor = _this$props.ctaColor,
        ctaInverted = _this$props.ctaInverted;
      var buttonColor = color === null || color === undefined ? {
        color: ctaColor
      } : {
        color: color
      };
      var buttonInverted = inverted === null || inverted === undefined ? {
        inverted: ctaInverted
      } : {};
      return _objectSpread(_objectSpread(_objectSpread({
        className: "cta-".concat(index)
      }, cta), buttonColor), buttonInverted);
    }
  }, {
    key: "getOverlayContainerStyle",
    value: function getOverlayContainerStyle() {
      var _this$props2 = this.props,
        containerAs = _this$props2.containerAs,
        containerColor = _this$props2.containerColor;
      if (containerAs === 'solid') return {
        backgroundColor: containerColor,
        opacity: 0.9
      };
      if (containerAs === 'outline') return {
        borderStyle: 'solid',
        borderColor: 'white'
      };
      return {};
    }
  }, {
    key: "getColumnStyle",
    value: function getColumnStyle(type, value) {
      var _this$props3 = this.props,
        height = _this$props3.height,
        textAlign = _this$props3.textAlign;
      var baseStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height,
        display: 'flex',
        alignItems: textAlign,
        justifyContent: 'center',
        padding: '1em'
      };
      return type === 'image' ? _objectSpread(_objectSpread({}, baseStyle), {}, {
        backgroundImage: "url('".concat(value, "')")
      }) : _objectSpread({}, baseStyle);
    }
  }, {
    key: "getBackgroundMetadata",
    value: function getBackgroundMetadata() {
      var _this$props4 = this.props,
        images = _this$props4.images,
        containerColor = _this$props4.containerColor,
        address = _this$props4.address,
        showMap = _this$props4.showMap;
      var displayMap = address && showMap || !images || images.length === 0;
      return {
        background: displayMap ? containerColor : images[0],
        content: displayMap ? /*#__PURE__*/React.createElement("div", {
          style: {
            margin: '1em',
            padding: '0em'
          }
        }, /*#__PURE__*/React.createElement(Map, {
          address: address
        })) : null,
        type: 'image'
      };
    }
  }, {
    key: "requiresOverlay",
    value: function requiresOverlay() {
      var _this$props5 = this.props,
        images = _this$props5.images,
        overlay = _this$props5.overlay,
        address = _this$props5.address,
        showMap = _this$props5.showMap;
      if (_isEmpty(images)) {
        return false;
      }
      return overlay && !(address && showMap);
    }
  }, {
    key: "requiresOnlyText",
    value: function requiresOnlyText() {
      var _this$props6 = this.props,
        images = _this$props6.images,
        address = _this$props6.address;
      return _isEmpty(images) && !address;
    }
  }, {
    key: "renderCTA",
    value: function renderCTA(ctaProps) {
      var text = ctaProps.text,
        link = ctaProps.link,
        internal = ctaProps.internal,
        color = ctaProps.color,
        inverted = ctaProps.inverted,
        internalLinkComponent = ctaProps.internalLinkComponent,
        className = ctaProps.className;
      return internal ? /*#__PURE__*/React.createElement(Event, {
        event: {
          category: 'Hero CTAs',
          action: 'Click',
          label: text
        },
        eventType: "click"
      }, /*#__PURE__*/React.createElement(InternalLink, {
        as: internalLinkComponent || 'a',
        to: link,
        className: className
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          marginTop: '1em'
        },
        color: color,
        inverted: inverted
      }, text))) : /*#__PURE__*/React.createElement(OutboundLink, {
        style: {
          marginTop: '1em'
        },
        color: color,
        inverted: inverted,
        as: Button,
        to: link,
        label: text,
        className: className,
        eventLabel: text
      });
    }
  }, {
    key: "renderCTAS",
    value: function renderCTAS() {
      var _this = this;
      var ctas = this.props.ctas;
      return /*#__PURE__*/React.createElement("div", null, ctas.map(function (cta, index) {
        return _this.renderCTA(_this.getCTAProps(cta, index));
      }));
    }
  }, {
    key: "renderHeaderContent",
    value: function renderHeaderContent() {
      var _this$props7 = this.props,
        header = _this$props7.header,
        tagline = _this$props7.tagline,
        ctas = _this$props7.ctas,
        textColor = _this$props7.textColor,
        textAlign = _this$props7.textAlign;
      var forceCenterAlign = this.requiresOverlay() || this.requiresOnlyText();
      var headerStyle = {
        padding: '1em',
        textAlign: forceCenterAlign ? 'center' : textAlign
      };
      return /*#__PURE__*/React.createElement("div", {
        style: headerStyle
      }, header && /*#__PURE__*/React.createElement("h1", {
        style: {
          color: textColor
        }
      }, header), tagline && /*#__PURE__*/React.createElement("div", {
        style: {
          color: textColor
        }
      }, tagline), ctas && ctas.length > 0 && this.renderCTAS(ctas));
    }
  }, {
    key: "renderOverlayContainer",
    value: function renderOverlayContainer() {
      var _this$props8 = this.props,
        containerAs = _this$props8.containerAs,
        containerColor = _this$props8.containerColor;
      var containerStyle = _objectSpread(_objectSpread({}, this.getOverlayContainerStyle()), {}, {
        padding: '2em',
        justifyContent: 'center',
        display: 'inline-block'
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "hero-background ".concat(containerAs === 'solid' && containerColor),
        style: containerStyle
      }, this.renderHeaderContent());
    }
  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      var _this$props9 = this.props,
        images = _this$props9.images,
        showMultiple = _this$props9.showMultiple,
        containerAs = _this$props9.containerAs,
        overlay = _this$props9.overlay,
        parallax = _this$props9.parallax,
        width = _this$props9.width,
        carouselOptions = _this$props9.carouselOptions;
      var bannerProps = null;
      if (images) {
        bannerProps = images.length > 1 && showMultiple ? {
          as: 'carousel',
          backgroundImage: images[0],
          galleryImages: images,
          carouselOptions: _objectSpread(_objectSpread({}, carouselOptions), {}, {
            autoScroll: true
          })
        } : {
          as: 'banner',
          backgroundImage: images[0]
        };
      }
      return /*#__PURE__*/React.createElement(ImageBanner, _extends({
        header: this.renderOverlayContainer(),
        parallax: parallax,
        overlay: overlay && containerAs !== 'solid' ? 'dark' : 'none',
        width: width
      }, bannerProps));
    }
  }, {
    key: "renderTiles",
    value: function renderTiles(items) {
      var _this2 = this;
      var gutter = this.props.gutter;
      return /*#__PURE__*/React.createElement(Grid, {
        stackable: true,
        verticalAlign: "middle",
        columns: 2
      }, items.map(function (_ref) {
        var background = _ref.background,
          content = _ref.content,
          link = _ref.link,
          type = _ref.type;
        return /*#__PURE__*/React.createElement(Grid.Column, {
          key: link,
          as: "a",
          href: link,
          width: type === 'image' ? 11 : 5,
          style: !gutter ? _this2.getColumnStyle(type, background) : {},
          className: "hero-background ".concat(background)
        }, /*#__PURE__*/React.createElement("div", {
          style: gutter ? _this2.getColumnStyle(type, background) : {}
        }, content));
      }));
    }
  }, {
    key: "renderTileHero",
    value: function renderTileHero() {
      var _this$props10 = this.props,
        containerColor = _this$props10.containerColor,
        textAlign = _this$props10.textAlign;
      var graphic = this.getBackgroundMetadata();
      var block = {
        background: containerColor,
        content: this.renderHeaderContent(),
        type: 'color'
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "hero-element-desktop"
      }, textAlign === 'right' ? this.renderTiles([block, graphic]) : this.renderTiles([graphic, block])), /*#__PURE__*/React.createElement("span", {
        className: "hero-element-mobile"
      }, this.renderOverlay()));
    }
  }, {
    key: "renderImagelessHero",
    value: function renderImagelessHero() {
      var containerColor = this.props.containerColor;
      var imagelessStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '15%',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        padding: '1em',
        backgroundColor: containerColor
      };
      return /*#__PURE__*/React.createElement(Grid, {
        verticalAlign: "middle",
        columns: 1
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        width: 16,
        style: imagelessStyle,
        className: "hero-background ".concat(containerColor)
      }, this.renderHeaderContent()));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.requiresOnlyText()) {
        return this.renderImagelessHero();
      }
      return this.requiresOverlay() ? this.renderOverlay() : this.renderTileHero();
    }
  }]);
  return HeroElement;
}(React.Component);
export { HeroElement as default };
HeroElement.defaultProps = {
  carouselOptions: {
    autoScroll: true,
    autoScrollTime: 5000
  },
  images: null,
  tagline: null,
  showMap: false,
  address: null,
  ctas: [],
  ctaColor: 'primary',
  ctaInverted: true,
  containerColor: 'primary',
  textColor: 'white',
  textAlign: 'center',
  showMultiple: true,
  overlay: true,
  fullWidth: true,
  parallax: true,
  containerAs: 'solid',
  height: 500,
  gutter: false,
  internalLinkComponent: null,
  width: 2000
};